<template>
  <div id="content" class="crpg-o-top-topCommon">
    <!-- TODO： location code-->
    <CMS
      contents_type="block_contents"
      location_code="CRPG_TOP_02_001-carousel"
      view_type="paragraphImage_carousel"
      class="carousel"
    />
    <div id="menus" class="crpg-o-top-topCommon__menus">
      <CMS
        contents_type="block_contents"
        location_code="CRPG_TOP_03_001-contents"
      />
    </div>
    <div class="news-contents">
      <div class="title">
        <div class="eng">Infromation</div>
        <div class="jp">お知らせ</div>
      </div>
      <OrganismsNewsList :showTitle="false" :maxNumOfDisplay="5" />
    </div>
  </div>
</template>

<script>
import OrganismsNewsList from "@/components/organisms/news/List.vue";

export default {
  components: {
    OrganismsNewsList,
  },
  data() {
    return {
      normalNews: [],
    };
  },
  methods: {
    async topNews(obj) {
      this.normalNews = [];
      if (obj.length === 0) {
        return;
      }
      const objects = await obj?.data?.objects;
      if (!objects) return;
      objects.forEach((items) => {
        if (items.data.length > 0) {
          items.data.forEach((item) => {
            if (items.contentId === "news_top") {
              this.normalNews.push({
                display_title: item.display_title,
                pub_date: item.pub_date,
                id: item.id,
                news_name: item.news_type_name,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/organisms/top/topContent.scss";
</style>
